import { cn } from "@/lib/cn";

/**
 * Shimmering placeholder for a chart that is still LOADING (DSGN-13).
 *
 * Use in `isLoading` branches ONLY — a resolved-but-empty result keeps
 * using `<EmptyState>` (whose docstring reserves it for genuinely-empty
 * data), so "still fetching" and "site has no data" stop looking identical.
 *
 * Visuals come from the existing `.ems-skeleton` shimmer in styles.css.
 * Default height matches the common chart-card body (~260 px); pass the
 * chart's real height so the layout doesn't jump when data arrives.
 */
export function ChartSkeleton({
  height = 260,
  className,
}: {
  height?: number;
  className?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={cn("ems-skeleton w-full", className)}
      style={{ height }}
    />
  );
}
